module.exports = __webpack_public_path__ + "img/wx-icon.1f5178cc.png";